module.exports = __webpack_public_path__ + "img/up-arrow.060ea651.svg";